import React, { useEffect, useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import GalaxyLayout from "../../client/components/layout/GalaxyLayout";
import "../../../assets/galaxy/RangBaz.css";
import { useParams } from "react-router-dom";

export default function GalaxyHome() {
  const { tabId } = useParams();
  const [cardShow, setCardShow] = useState("All");

  useEffect(() => {
    if (tabId == undefined) {
      setCardShow("All");
    } else {
      if (tabId == 1) {
        setCardShow("All");
      } else if (tabId == 2) {
        setCardShow("Crash");
      } else {
        setCardShow("Card");
      }
    }
  }, []); // Empty dependency array i am supposed to make some changes in my css so using inspect to find this - 

  return (
    <GalaxyLayout>
      <div>
        <div class="container mt-4" id="rbc-app">
          <div>
            <div class="main-banner">
              <center>
                <img src="../assets/galaxy/img/MainGalaxyLogo.png" />
              </center>
            </div>

            <div class="promo-section">
              <Link class="promo-card nav-link " to="/dt-galaxy" onclick="loadGame(777706)" />
              <Link class="promo-card nav-link " to="/tp20-galaxy" onclick="loadGame(777703)" />
              <Link class="promo-card nav-link " to="/luckyjet-galaxy" onclick="loadGame(777701)" />
            </div>

            <div class="tabs-section">
              <ul class="nav nav-tabs-glxy mobile-Tab">
                <li class="nav-item rbc-games-tab" data-id="0">
                  <Link
                    class="nav-link active"
                    onClick={() => setCardShow("All")}
                  >
                    <span class="tab-icon">🎮</span>
                    All Games
                    <span class="badge bg-warning text-dark">6</span>
                  </Link>
                </li>
                <li class="nav-item rbc-games-tab" data-id="1">
                  <Link class="nav-link " onClick={() => setCardShow("Crash")}>
                    <span class="tab-icon">🎮</span>
                    Crash
                    <span class="badge bg-warning text-dark">1</span>
                  </Link>
                </li>
                <li class="nav-item rbc-games-tab" data-id="3">
                  <Link class="nav-link " onClick={() => setCardShow("Card")}>
                    <span class="tab-icon">🎮</span>
                    Card
                    <span class="badge bg-warning text-dark">5</span>
                  </Link>
                </li>{" "}
              </ul>

              <ul class="nav nav-tabs desktop-tab nav-tabs-glxy">
                <li class="nav-item rbc-games-tab" data-id="0">
                  <Link
                    class="nav-link active"
                    onClick={() => setCardShow("All")}
                  >
                    <span class="tab-icon">🎮</span>
                    All Games
                    <span class="badge bg-warning text-dark">6</span>
                  </Link>
                </li>
                <li class="nav-item rbc-games-tab" data-id="1">
                  <Link class="nav-link " onClick={() => setCardShow("Crash")}>
                    <span class="tab-icon">🎮</span>
                    Crash
                    <span class="badge bg-warning text-dark">1</span>
                  </Link>
                </li>
                <li class="nav-item rbc-games-tab" data-id="3">
                  <Link class="nav-link " onClick={() => setCardShow("Card")}>
                    <span class="tab-icon">🎮</span>
                    Card
                    <span class="badge bg-warning text-dark">5</span>
                  </Link>
                </li>{" "}
              </ul>
            </div>

            <div class="game-section">
              <div
                class="game-card rbc-game-launcher show_1"
                style={{
                  display:
                    cardShow == "All" || cardShow == "Crash" ? "" : "none"
                }}
              >
                <Link class="nav-link " to="/luckyjet-galaxy">
                  <img src="../assets/galaxy/img/777701.webp" alt="Lucky Jet" />
                  <div class="game-title">Lucky Jet</div>
                </Link>
              </div>
              <div
                class="game-card rbc-game-launcher show_3"
                style={{
                  display: cardShow == "All" || cardShow == "Card" ? "" : "none"
                }}
              >
                <Link class="nav-link " to="/lucky7-galaxy">
                  <img src="../assets/galaxy/img/777702.webp" alt="7-Up-Down" />
                  <div class="game-title">7-Up-Down</div>
                </Link>
              </div>
              <div
                class="game-card rbc-game-launcher show_3"
                style={{
                  display: cardShow == "All" || cardShow == "Card" ? "" : "none"
                }}
              >
                <Link class="nav-link " to="/tp20-galaxy">
                  <img
                    src="../assets/galaxy/img/777703.webp"
                    alt="TeenPatti T20"
                  />
                  <div class="game-title">TeenPatti T20</div>
                </Link>
              </div>
              <div
                class="game-card rbc-game-launcher show_3"
                style={{
                  display: cardShow == "All" || cardShow == "Card" ? "" : "none"
                }}
              >
                <Link class="nav-link " to="/hilo-galaxy">
                  <img src="../assets/galaxy/img/777704.webp" alt="HiLo" />
                  <div class="game-title">HiLo</div>
                </Link>
              </div>
              <div
                class="game-card rbc-game-launcher show_3"
                style={{
                  display: cardShow == "All" || cardShow == "Card" ? "" : "none"
                }}
              >
                {" "}
                <Link class="nav-link " to="/andarbahar-galaxy">
                  <img
                    src="../assets/galaxy/img/777705.webp"
                    alt="Andar Bahar"
                  />
                  <div class="game-title">Andar Bahar</div>
                </Link>
              </div>
              <div
                class="game-card rbc-game-launcher show_3"
                style={{
                  display: cardShow == "All" || cardShow == "Card" ? "" : "none"
                }}
              >
                <Link class="nav-link " to="/dt-galaxy">
                  <img
                    src="../assets/galaxy/img/777706.webp"
                    alt="Dragon Tiger"
                  />
                  <div class="game-title">Dragon Tiger</div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </GalaxyLayout>
  );
}
